import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'DateTimePicker',
  label: 'Date Time Picker',
  icon: 'DocumentTextIcon',
  description: 'Enables the selection of date and time',
  properties: [
    {
      label: 'Date/Time Value',
      name: 'datetimeValue',
      description:
        'Enter a value for the Date/Time. It can accept placeholders of the form {{it.someobject.field}}',
      editor: 'textbox',
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Date/Time Function',
      name: 'datetimeFunction',
      editor: 'codeeditor',
      codeEditorHeight: '50vh',
      defaultLanguage: 'html',
      description:
        'You can provide a function instead of specific value. The function will be passed { local, data, user, documents, selections }. Simply return a javascript date time object from the function that you want to display in the date time picker.',
      displayWhen: [
        {
          field: 'datetimeValue',
          operator: 'IS_EMPTY',
          value: ''
        }
      ],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Local Store Key Name',
      name: 'localStoreKeyName',
      description:
        'The name of a key in the local store that the date and time will be stored under.',
      editor: 'textbox',
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    }
  ]
};

export default fields;
